/* eslint-disable  react/destructuring-assignment */
import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';
import { ThemeProvider } from '@workboard/wobo-ui';
import OkrHead from './okr-head';
import OkrTab from './okr-tabs';
import OkrContainer from './okr-container';
import { OkrPopUp } from '../../types/okrpopup.types';
import * as OkrPopIpActions from '../../actions/okr_popup.action';
import { krdetailActions } from '../../../actions/krDetails.actions';

const OKRPopUpComponent = (props: OkrPopUp) => {
    const getParent = () => document.getElementById('page')

    return (
        props.show && (
            <Modal
                isOpen={props.show}
                contentLabel="Objectives"
                ariaHideApp={false}
                parentSelector={getParent}
                className="react-modal-okr-popup"
                overlayClassName="react-modal-okr-popup-overlay"
                onRequestClose={() => props.dispatch(OkrPopIpActions.UpdateModal(false))}
                shouldCloseOnOverlayClick={false}
                shouldReturnFocusAfterClose
            >
                <ThemeProvider>
                    <div className="okr-popup-shell">
                        <OkrHead {...props} />
                        <OkrTab {...props} />
                        <OkrContainer {...props} />
                    </div>
                </ThemeProvider>
            </Modal>
        )
    )
}

const mapStateToProps = (state: any) => ({
    goalData: state.okrPopUpReducer,
    goalId: state.okrPopUpReducer.goalId,
    OkrActiveTab: state.okrPopUpReducer.OkrActiveTab,
    OkrPopTabs: state.okrPopUpReducer.OkrPopTabs,
    show: state.okrPopUpReducer.show,
    goalPopUpMetric: state.okrPopUpReducer.goalPopUpMetric,
    pathInfo: state.okrPopUpReducer.pathInfo,
    cacheKeySet: state.okrPopUpReducer.cacheKeySet,
    dataSource: state.KrReducers.dataSource
});
const actions = { ...OkrPopIpActions, ...krdetailActions };
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    actions: bindActionCreators(actions, dispatch),
    dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(OKRPopUpComponent);
